module.exports = __webpack_public_path__ + "static/media/youtube-icon.0d3a9bc3.svg";